import { IonText } from '@ionic/react';
import { DateTime } from 'luxon';
import React from 'react';
import * as commonCss from '../../styles/common';

export const LastUpdatedText: React.FC<{ lastSampledAt?: string }> = ({ lastSampledAt }) => {
  const [lastUpdatedString, setLastUpdatedString] = React.useState<string | null>(null);

  const updateTime = React.useCallback(() => {
    if (!lastSampledAt) {
      setLastUpdatedString(null);
      return;
    }
    // Note: the API returns hourly aggregates that correspond to the
    // beginning of the output period.
    // Example: if the lastSampledAt is 2025-01-01T10:00:00Z, the target
    // period is 2025-01-01T10:00:00Z - 2025-01-01T11:00:00Z. Therefore,
    // we add an hour to the lastSampledAt to get the end of the period.
    const relativeTime = DateTime.fromISO(lastSampledAt).plus({ hours: 1 }).toRelative({ unit: 'minutes' });
    setLastUpdatedString(`Measured ${relativeTime}`);
  }, [lastSampledAt]);

  React.useEffect(() => {
    updateTime(); // Update immediately on startup
    const interval = setInterval(updateTime, 5_000);
    return () => clearInterval(interval);
  }, [updateTime]);
  return <IonText css={[commonCss.smallText, commonCss.italics]}>{lastUpdatedString}</IonText>;
};
